import { render, staticRenderFns } from "./W0126V0001.vue?vue&type=template&id=087d226f&scoped=true&"
import script from "./W0126V0001.vue?vue&type=script&lang=js&"
export * from "./W0126V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0126V0001.vue?vue&type=style&index=0&id=087d226f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d226f",
  null
  
)

export default component.exports